import { AgencyLookupStore } from 'app/shared/lookup/agency-lookup/agency-lookup.store';
import { MultiAgencyService } from './../../shared/multi-agency/multi-agency.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { User } from '../../auth/models/User';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { List } from 'immutable';
import { debug } from 'console';

@Component({
  selector: 'pioneer-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  public isEventSelected: boolean;

  userIsLoggedIn: Observable<boolean>;
  user: User;
  public imagesUrl = '';

  agencies = List<MultiAgency>();
  showSupportButton = false;

  constructor(
    private authenticationStore: AuthenticationStore,
    private environment: EnvironmentConfiguration,
    private multiAgencyService: MultiAgencyService,
    private agencyLookupStore: AgencyLookupStore
  ) {}

  ngOnInit() {
    this.userIsLoggedIn = this.authenticationStore.isLoggedIn();
    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.multiAgencyService.isEventSelected$.subscribe((event) => {
      this.isEventSelected = event;
    });

    this.multiAgencyService.agencies.subscribe((agencies) => {
      this.agencies = agencies;
    });
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;

    const gpWindow = (window as any);
    if (gpWindow.configGroupPay && gpWindow.configGroupPay.showAgencyDashboard && this.authenticationStore.isAgencyUser()) {
      this.multiAgencyService.defaultAgencyId.subscribe((agencyId: string) => {
        this.agencyLookupStore
          .isSubscriberAgency(agencyId)
          .subscribe((isSubscriber) => {
            let isSubscriberAgency = Boolean(isSubscriber);
            this.showSupportButton =
              this.authenticationStore.hasPermission('ViewDashboard') &&
              isSubscriberAgency;
          });
      });
    } else {
      this.showSupportButton = false;
    }
  }

  onLogout() {
    this.authenticationStore.logout();
  }

  get username() {
    return {
      username: this.user.username,
    };
  }

  onClickPrivacy(event) {
    window.open(this.environment.policyUrl, '_blank');
  }

  getPortalUrl() {
    return this.environment.portalUrl;
  }

  onClickRedirect(event) {
    window.open(this.getPortalUrl(), '_self');
  }

  get defaultAgencyId(): Observable<string> {
    return this.multiAgencyService.defaultAgencyId;
  }

  get defaultAgencyName(): Observable<string> {
    return this.multiAgencyService.defaultAgencyName;
  }

  get isMultiAgency(): Observable<boolean> {
    return this.multiAgencyService.isMultiAgency();
  }

  get isSingleAgency(): Observable<boolean> {
    return this.multiAgencyService.isSingleAgency();
  }

  onClickAgency(agency: MultiAgency): void {
    if (this.multiAgencyService.oldAgencyId !== agency.agencyId) {
      this.authenticationStore
        .updateIataFromToken(agency.agencyId)
        .subscribe(() => {
          this.multiAgencyService.setAgencySelectedUI(true);
          this.multiAgencyService.setDefaultAgency(agency);
        });
    }
  }

  onClickSupport(event) {
    window.open(this.environment.supportUrl, '_blank');
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/navigation/header/header.component.ts